var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var Client;
(function (Client) {
    Client["AdminClient"] = "ADMIN_CLIENT";
    Client["SchoolClient"] = "SCHOOL_CLIENT";
    Client["StudentClient"] = "STUDENT_CLIENT";
    Client["IbarakiCity"] = "IBARAKI_CITY";
})(Client || (Client = {}));
export var ClubActivity;
(function (ClubActivity) {
    ClubActivity["NotSet"] = "NOT_SET";
    ClubActivity["TrackAndField"] = "TRACK_AND_FIELD";
    ClubActivity["Soccer"] = "SOCCER";
    ClubActivity["Tennis"] = "TENNIS";
    ClubActivity["SoftTennis"] = "SOFT_TENNIS";
    ClubActivity["Baseball"] = "BASEBALL";
    ClubActivity["SoftballBaseball"] = "SOFTBALL_BASEBALL";
    ClubActivity["Basketball"] = "BASKETBALL";
    ClubActivity["Volleyball"] = "VOLLEYBALL";
    ClubActivity["Badminton"] = "BADMINTON";
    ClubActivity["Fencing"] = "FENCING";
    ClubActivity["Kendo"] = "KENDO";
    ClubActivity["TableTennis"] = "TABLE_TENNIS";
    ClubActivity["Judo"] = "JUDO";
    ClubActivity["Kyudo"] = "KYUDO";
    ClubActivity["Swimming"] = "SWIMMING";
    ClubActivity["MountainClimbing"] = "MOUNTAIN_CLIMBING";
    ClubActivity["Cycling"] = "CYCLING";
    ClubActivity["Ski"] = "SKI";
    ClubActivity["Science"] = "SCIENCE";
    ClubActivity["Physics"] = "PHYSICS";
    ClubActivity["Chemistry"] = "CHEMISTRY";
    ClubActivity["EarthScience"] = "EARTH_SCIENCE";
    ClubActivity["BrassBand"] = "BRASS_BAND";
    ClubActivity["History"] = "HISTORY";
    ClubActivity["Railroad"] = "RAILROAD";
    ClubActivity["Shogi"] = "SHOGI";
    ClubActivity["Music"] = "MUSIC";
    ClubActivity["MusicBand"] = "MUSIC_BAND";
    ClubActivity["Quiz"] = "QUIZ";
    ClubActivity["ModelBuilding"] = "MODEL_BUILDING";
    ClubActivity["Biology"] = "BIOLOGY";
    ClubActivity["Igo"] = "IGO";
    ClubActivity["Programming"] = "PROGRAMMING";
    ClubActivity["Dance"] = "DANCE";
    ClubActivity["Creative"] = "CREATIVE";
    ClubActivity["Fishing"] = "FISHING";
    ClubActivity["Art"] = "ART";
    ClubActivity["Magic"] = "MAGIC";
    ClubActivity["Origami"] = "ORIGAMI";
    ClubActivity["IceHockey"] = "ICE_HOCKEY";
    ClubActivity["Mathematics"] = "MATHEMATICS";
    ClubActivity["EnglishSpeakingSociety"] = "ENGLISH_SPEAKING_SOCIETY";
    ClubActivity["Literature"] = "LITERATURE";
    ClubActivity["Other"] = "OTHER";
})(ClubActivity || (ClubActivity = {}));
export var Era;
(function (Era) {
    Era["Showa"] = "SHOWA";
    Era["Heisei"] = "HEISEI";
    Era["Reiwa"] = "REIWA";
})(Era || (Era = {}));
export var SchoolCategory;
(function (SchoolCategory) {
    SchoolCategory["ElementarySchool"] = "ELEMENTARY_SCHOOL";
    SchoolCategory["JuniorHighSchool"] = "JUNIOR_HIGH_SCHOOL";
    SchoolCategory["HighSchool"] = "HIGH_SCHOOL";
    SchoolCategory["Other"] = "OTHER";
})(SchoolCategory || (SchoolCategory = {}));
export var SchoolInvitationCodeType;
(function (SchoolInvitationCodeType) {
    SchoolInvitationCodeType["SchoolAdmin"] = "SCHOOL_ADMIN";
    SchoolInvitationCodeType["GradeAdmin"] = "GRADE_ADMIN";
    SchoolInvitationCodeType["Teacher"] = "TEACHER";
})(SchoolInvitationCodeType || (SchoolInvitationCodeType = {}));
export var SchoolType;
(function (SchoolType) {
    SchoolType["Private"] = "PRIVATE";
    SchoolType["Public"] = "PUBLIC";
    SchoolType["Other"] = "OTHER";
})(SchoolType || (SchoolType = {}));
export var UserGender;
(function (UserGender) {
    UserGender["NotSet"] = "NOT_SET";
    UserGender["Male"] = "MALE";
    UserGender["Female"] = "FEMALE";
})(UserGender || (UserGender = {}));
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "ADMIN";
    UserRole["LocalGovernment"] = "LOCAL_GOVERNMENT";
    UserRole["SchoolAdmin"] = "SCHOOL_ADMIN";
    UserRole["GradeAdmin"] = "GRADE_ADMIN";
    UserRole["Teacher"] = "TEACHER";
    UserRole["Student"] = "STUDENT";
    UserRole["Guest"] = "GUEST";
})(UserRole || (UserRole = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Desc"] = "DESC";
    SortOrder["Asc"] = "ASC";
})(SortOrder || (SortOrder = {}));
export var AuthorizeUserDocument = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation AuthorizeUser($uid: String!) {\n    auth(uid: $uid) {\n      token\n      error\n    }\n  }\n"], ["\n  mutation AuthorizeUser($uid: String!) {\n    auth(uid: $uid) {\n      token\n      error\n    }\n  }\n"])));
/**
 * __useAuthorizeUserMutation__
 *
 * To run a mutation, you first call `useAuthorizeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthorizeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authorizeUserMutation, { data, loading, error }] = useAuthorizeUserMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useAuthorizeUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AuthorizeUserDocument, options);
}
export var RegisterUserDocument = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  mutation RegisterUser($input: RegisterUserInput!) {\n    registerUser(input: $input) {\n      data {\n        _id\n      }\n      token\n      error\n    }\n  }\n"], ["\n  mutation RegisterUser($input: RegisterUserInput!) {\n    registerUser(input: $input) {\n      data {\n        _id\n      }\n      token\n      error\n    }\n  }\n"])));
/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RegisterUserDocument, options);
}
export var UpdateUserDocument = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      data {\n        _id\n      }\n      token\n      error\n    }\n  }\n"], ["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      data {\n        _id\n      }\n      token\n      error\n    }\n  }\n"])));
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateUserDocument, options);
}
export var CreateSchoolDocument = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  mutation CreateSchool($input: CreateSchoolInput!) {\n    createSchool(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation CreateSchool($input: CreateSchoolInput!) {\n    createSchool(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useCreateSchoolMutation__
 *
 * To run a mutation, you first call `useCreateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchoolMutation, { data, loading, error }] = useCreateSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSchoolMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateSchoolDocument, options);
}
export var UpdateSchoolDocument = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  mutation UpdateSchool($input: UpdateSchoolInput!) {\n    updateSchool(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation UpdateSchool($input: UpdateSchoolInput!) {\n    updateSchool(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useUpdateSchoolMutation__
 *
 * To run a mutation, you first call `useUpdateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSchoolMutation, { data, loading, error }] = useUpdateSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSchoolMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateSchoolDocument, options);
}
export var LinkSchoolTestYearDocument = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  mutation LinkSchoolTestYear($input: SchoolLinkTestYearInput!) {\n    linkSchoolTestYear(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation LinkSchoolTestYear($input: SchoolLinkTestYearInput!) {\n    linkSchoolTestYear(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useLinkSchoolTestYearMutation__
 *
 * To run a mutation, you first call `useLinkSchoolTestYearMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSchoolTestYearMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSchoolTestYearMutation, { data, loading, error }] = useLinkSchoolTestYearMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkSchoolTestYearMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(LinkSchoolTestYearDocument, options);
}
export var SchoolUnlinkTeacherDocument = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  mutation SchoolUnlinkTeacher($input: SchoolUnlinkTeacherInput!) {\n    schoolUnlinkTeacher(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolUnlinkTeacher($input: SchoolUnlinkTeacherInput!) {\n    schoolUnlinkTeacher(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolUnlinkTeacherMutation__
 *
 * To run a mutation, you first call `useSchoolUnlinkTeacherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUnlinkTeacherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUnlinkTeacherMutation, { data, loading, error }] = useSchoolUnlinkTeacherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolUnlinkTeacherMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolUnlinkTeacherDocument, options);
}
export var SchoolUnlinkStudentDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  mutation SchoolUnlinkStudent($input: SchoolUnlinkStudentInput!) {\n    schoolUnlinkStudent(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolUnlinkStudent($input: SchoolUnlinkStudentInput!) {\n    schoolUnlinkStudent(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolUnlinkStudentMutation__
 *
 * To run a mutation, you first call `useSchoolUnlinkStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolUnlinkStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolUnlinkStudentMutation, { data, loading, error }] = useSchoolUnlinkStudentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolUnlinkStudentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolUnlinkStudentDocument, options);
}
export var RegisterGradeDocument = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  mutation RegisterGrade($input: RegisterSchoolGradeInput!) {\n    registerGrade(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation RegisterGrade($input: RegisterSchoolGradeInput!) {\n    registerGrade(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useRegisterGradeMutation__
 *
 * To run a mutation, you first call `useRegisterGradeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterGradeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerGradeMutation, { data, loading, error }] = useRegisterGradeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterGradeMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(RegisterGradeDocument, options);
}
export var TeacherLinkSchoolDocument = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  mutation TeacherLinkSchool($input: TeacherLinkSchoolInput!) {\n    teacherLinkSchool(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation TeacherLinkSchool($input: TeacherLinkSchoolInput!) {\n    teacherLinkSchool(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useTeacherLinkSchoolMutation__
 *
 * To run a mutation, you first call `useTeacherLinkSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeacherLinkSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teacherLinkSchoolMutation, { data, loading, error }] = useTeacherLinkSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeacherLinkSchoolMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(TeacherLinkSchoolDocument, options);
}
export var SchoolAddStudentDocument = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  mutation SchoolAddStudent($input: SchoolAddStudentInput!) {\n    schoolAddStudent(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolAddStudent($input: SchoolAddStudentInput!) {\n    schoolAddStudent(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolAddStudentMutation__
 *
 * To run a mutation, you first call `useSchoolAddStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolAddStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolAddStudentMutation, { data, loading, error }] = useSchoolAddStudentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolAddStudentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolAddStudentDocument, options);
}
export var SchoolEditStudentDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  mutation SchoolEditStudent($input: SchoolEditStudentInput!) {\n    schoolEditStudent(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolEditStudent($input: SchoolEditStudentInput!) {\n    schoolEditStudent(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolEditStudentMutation__
 *
 * To run a mutation, you first call `useSchoolEditStudentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolEditStudentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolEditStudentMutation, { data, loading, error }] = useSchoolEditStudentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolEditStudentMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolEditStudentDocument, options);
}
export var SchoolSubmitStudentQuestionnarieDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentQuestionnarie(\n    $input: SchoolSubmitStudentQuestionnarieInput!\n  ) {\n    schoolSubmitStudentQuestionnarie(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentQuestionnarie(\n    $input: SchoolSubmitStudentQuestionnarieInput!\n  ) {\n    schoolSubmitStudentQuestionnarie(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentQuestionnarieMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentQuestionnarieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentQuestionnarieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentQuestionnarieMutation, { data, loading, error }] = useSchoolSubmitStudentQuestionnarieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentQuestionnarieMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentQuestionnarieDocument, options);
}
export var SchoolSubmitStudentGripTestDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentGripTest(\n    $input: SchoolSubmitStudentGripTestInput!\n  ) {\n    schoolSubmitStudentGripTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentGripTest(\n    $input: SchoolSubmitStudentGripTestInput!\n  ) {\n    schoolSubmitStudentGripTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentGripTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentGripTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentGripTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentGripTestMutation, { data, loading, error }] = useSchoolSubmitStudentGripTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentGripTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentGripTestDocument, options);
}
export var SchoolSubmitStudentSitUpsTestDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentSitUpsTest(\n    $input: SchoolSubmitStudentSitUpsTestInput!\n  ) {\n    schoolSubmitStudentSitUpsTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentSitUpsTest(\n    $input: SchoolSubmitStudentSitUpsTestInput!\n  ) {\n    schoolSubmitStudentSitUpsTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentSitUpsTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentSitUpsTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentSitUpsTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentSitUpsTestMutation, { data, loading, error }] = useSchoolSubmitStudentSitUpsTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentSitUpsTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentSitUpsTestDocument, options);
}
export var SchoolSubmitStudentBendingTestDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentBendingTest(\n    $input: SchoolSubmitStudentBendingTestInput!\n  ) {\n    schoolSubmitStudentBendingTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentBendingTest(\n    $input: SchoolSubmitStudentBendingTestInput!\n  ) {\n    schoolSubmitStudentBendingTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentBendingTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentBendingTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentBendingTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentBendingTestMutation, { data, loading, error }] = useSchoolSubmitStudentBendingTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentBendingTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentBendingTestDocument, options);
}
export var SchoolSubmitStudentSideJumpTestDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentSideJumpTest(\n    $input: SchoolSubmitStudentSideJumpTestInput!\n  ) {\n    schoolSubmitStudentSideJumpTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentSideJumpTest(\n    $input: SchoolSubmitStudentSideJumpTestInput!\n  ) {\n    schoolSubmitStudentSideJumpTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentSideJumpTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentSideJumpTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentSideJumpTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentSideJumpTestMutation, { data, loading, error }] = useSchoolSubmitStudentSideJumpTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentSideJumpTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentSideJumpTestDocument, options);
}
export var SchoolSubmitStudentEnduranceRunTestDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentEnduranceRunTest(\n    $input: SchoolSubmitStudentEnduranceRunTestInput!\n  ) {\n    schoolSubmitStudentEnduranceRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentEnduranceRunTest(\n    $input: SchoolSubmitStudentEnduranceRunTestInput!\n  ) {\n    schoolSubmitStudentEnduranceRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentEnduranceRunTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentEnduranceRunTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentEnduranceRunTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentEnduranceRunTestMutation, { data, loading, error }] = useSchoolSubmitStudentEnduranceRunTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentEnduranceRunTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentEnduranceRunTestDocument, options);
}
export var SchoolSubmitStudentShuttleRunTestDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentShuttleRunTest(\n    $input: SchoolSubmitStudentShuttleRunTestInput!\n  ) {\n    schoolSubmitStudentShuttleRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentShuttleRunTest(\n    $input: SchoolSubmitStudentShuttleRunTestInput!\n  ) {\n    schoolSubmitStudentShuttleRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentShuttleRunTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentShuttleRunTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentShuttleRunTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentShuttleRunTestMutation, { data, loading, error }] = useSchoolSubmitStudentShuttleRunTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentShuttleRunTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentShuttleRunTestDocument, options);
}
export var SchoolSubmitStudentSprintRunTestDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentSprintRunTest(\n    $input: SchoolSubmitStudentSprintRunTestInput!\n  ) {\n    schoolSubmitStudentSprintRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentSprintRunTest(\n    $input: SchoolSubmitStudentSprintRunTestInput!\n  ) {\n    schoolSubmitStudentSprintRunTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentSprintRunTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentSprintRunTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentSprintRunTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentSprintRunTestMutation, { data, loading, error }] = useSchoolSubmitStudentSprintRunTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentSprintRunTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentSprintRunTestDocument, options);
}
export var SchoolSubmitStudentStandingJumpTestDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentStandingJumpTest(\n    $input: SchoolSubmitStudentStandingJumpTestInput!\n  ) {\n    schoolSubmitStudentStandingJumpTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentStandingJumpTest(\n    $input: SchoolSubmitStudentStandingJumpTestInput!\n  ) {\n    schoolSubmitStudentStandingJumpTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentStandingJumpTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentStandingJumpTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentStandingJumpTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentStandingJumpTestMutation, { data, loading, error }] = useSchoolSubmitStudentStandingJumpTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentStandingJumpTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentStandingJumpTestDocument, options);
}
export var SchoolSubmitStudentHandballThrowTestDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentHandballThrowTest(\n    $input: SchoolSubmitStudentHandballThrowTestInput!\n  ) {\n    schoolSubmitStudentHandballThrowTest(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentHandballThrowTest(\n    $input: SchoolSubmitStudentHandballThrowTestInput!\n  ) {\n    schoolSubmitStudentHandballThrowTest(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentHandballThrowTestMutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentHandballThrowTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentHandballThrowTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentHandballThrowTestMutation, { data, loading, error }] = useSchoolSubmitStudentHandballThrowTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentHandballThrowTestMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentHandballThrowTestDocument, options);
}
export var StudentLinkSchoolDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  mutation StudentLinkSchool($input: StudentLinkSchoolInput!) {\n    studentLinkSchool(input: $input) {\n      token\n      error\n    }\n  }\n"], ["\n  mutation StudentLinkSchool($input: StudentLinkSchoolInput!) {\n    studentLinkSchool(input: $input) {\n      token\n      error\n    }\n  }\n"])));
/**
 * __useStudentLinkSchoolMutation__
 *
 * To run a mutation, you first call `useStudentLinkSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentLinkSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentLinkSchoolMutation, { data, loading, error }] = useStudentLinkSchoolMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentLinkSchoolMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(StudentLinkSchoolDocument, options);
}
export var StudentSubmitQuestionnarieDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  mutation StudentSubmitQuestionnarie($input: StudentQuestionnarieInput!) {\n    studentSubmitQuestionnarie(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation StudentSubmitQuestionnarie($input: StudentQuestionnarieInput!) {\n    studentSubmitQuestionnarie(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useStudentSubmitQuestionnarieMutation__
 *
 * To run a mutation, you first call `useStudentSubmitQuestionnarieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSubmitQuestionnarieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSubmitQuestionnarieMutation, { data, loading, error }] = useStudentSubmitQuestionnarieMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentSubmitQuestionnarieMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(StudentSubmitQuestionnarieDocument, options);
}
export var SchoolSubmitStudentQuestionnaireV2Document = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  mutation SchoolSubmitStudentQuestionnaireV2(\n    $input: SchoolSubmitStudentQuestionnaireV2Input!\n  ) {\n    schoolSubmitStudentQuestionnaireV2(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation SchoolSubmitStudentQuestionnaireV2(\n    $input: SchoolSubmitStudentQuestionnaireV2Input!\n  ) {\n    schoolSubmitStudentQuestionnaireV2(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useSchoolSubmitStudentQuestionnaireV2Mutation__
 *
 * To run a mutation, you first call `useSchoolSubmitStudentQuestionnaireV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchoolSubmitStudentQuestionnaireV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schoolSubmitStudentQuestionnaireV2Mutation, { data, loading, error }] = useSchoolSubmitStudentQuestionnaireV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolSubmitStudentQuestionnaireV2Mutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SchoolSubmitStudentQuestionnaireV2Document, options);
}
export var StudentSubmitQuestionnaireV2Document = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  mutation StudentSubmitQuestionnaireV2($input: StudentQuestionnaireV2Input!) {\n    studentSubmitQuestionnaireV2(input: $input) {\n      success\n      error\n    }\n  }\n"], ["\n  mutation StudentSubmitQuestionnaireV2($input: StudentQuestionnaireV2Input!) {\n    studentSubmitQuestionnaireV2(input: $input) {\n      success\n      error\n    }\n  }\n"])));
/**
 * __useStudentSubmitQuestionnaireV2Mutation__
 *
 * To run a mutation, you first call `useStudentSubmitQuestionnaireV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentSubmitQuestionnaireV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentSubmitQuestionnaireV2Mutation, { data, loading, error }] = useStudentSubmitQuestionnaireV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentSubmitQuestionnaireV2Mutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(StudentSubmitQuestionnaireV2Document, options);
}
export var AnalyticsEventDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  mutation AnalyticsEvent($input: JSON!) {\n    analyticsEvent(input: $input)\n  }\n"], ["\n  mutation AnalyticsEvent($input: JSON!) {\n    analyticsEvent(input: $input)\n  }\n"])));
/**
 * __useAnalyticsEventMutation__
 *
 * To run a mutation, you first call `useAnalyticsEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsEventMutation, { data, loading, error }] = useAnalyticsEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsEventMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AnalyticsEventDocument, options);
}
export var AnalyticsEventsDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  mutation AnalyticsEvents($input: [JSON!]!) {\n    analyticsEvents(input: $input)\n  }\n"], ["\n  mutation AnalyticsEvents($input: [JSON!]!) {\n    analyticsEvents(input: $input)\n  }\n"])));
/**
 * __useAnalyticsEventsMutation__
 *
 * To run a mutation, you first call `useAnalyticsEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnalyticsEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [analyticsEventsMutation, { data, loading, error }] = useAnalyticsEventsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAnalyticsEventsMutation(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(AnalyticsEventsDocument, options);
}
export var AreasDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  query Areas($input: AreasInput) {\n    areas(input: $input) {\n      data {\n        _id\n        name\n      }\n    }\n  }\n"], ["\n  query Areas($input: AreasInput) {\n    areas(input: $input) {\n      data {\n        _id\n        name\n      }\n    }\n  }\n"
    /**
     * __useAreasQuery__
     *
     * To run a query within a React component, call `useAreasQuery` and pass it any options that fit your needs.
     * When your component renders, `useAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useAreasQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useAreasQuery__
 *
 * To run a query within a React component, call `useAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreasQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAreasQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(AreasDocument, options);
}
export function useAreasLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(AreasDocument, options);
}
export var PrefecturesDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  query Prefectures($input: PrefecturesInput) {\n    prefectures(input: $input) {\n      data {\n        _id\n        name\n        code\n        area\n      }\n    }\n  }\n"], ["\n  query Prefectures($input: PrefecturesInput) {\n    prefectures(input: $input) {\n      data {\n        _id\n        name\n        code\n        area\n      }\n    }\n  }\n"
    /**
     * __usePrefecturesQuery__
     *
     * To run a query within a React component, call `usePrefecturesQuery` and pass it any options that fit your needs.
     * When your component renders, `usePrefecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = usePrefecturesQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __usePrefecturesQuery__
 *
 * To run a query within a React component, call `usePrefecturesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrefecturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrefecturesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrefecturesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(PrefecturesDocument, options);
}
export function usePrefecturesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(PrefecturesDocument, options);
}
export var CitiesDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  query Cities($input: CitiesInput!) {\n    cities(input: $input) {\n      data {\n        _id\n        name\n      }\n    }\n  }\n"], ["\n  query Cities($input: CitiesInput!) {\n    cities(input: $input) {\n      data {\n        _id\n        name\n      }\n    }\n  }\n"
    /**
     * __useCitiesQuery__
     *
     * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
     * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useCitiesQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useCitiesQuery__
 *
 * To run a query within a React component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCitiesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CitiesDocument, options);
}
export function useCitiesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CitiesDocument, options);
}
export var JapanSchoolsDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  query JapanSchools($input: JapanSchoolsInput!) {\n    japanSchools(input: $input) {\n      totalCount\n      data {\n        _id\n        schoolName\n        schoolCode\n        schoolAddress\n        registered\n        school {\n          _id\n          attributes {\n            email\n            website\n            telephone\n            fax\n            schoolAdminName\n            schoolAdminEmail\n            onboardComplete\n            testYears\n            schoolAdminInvitationCode\n            teacherInvitationCode\n            otherSchoolCode\n          }\n          createdAt\n          updatedAt\n        }\n      }\n    }\n  }\n"], ["\n  query JapanSchools($input: JapanSchoolsInput!) {\n    japanSchools(input: $input) {\n      totalCount\n      data {\n        _id\n        schoolName\n        schoolCode\n        schoolAddress\n        registered\n        school {\n          _id\n          attributes {\n            email\n            website\n            telephone\n            fax\n            schoolAdminName\n            schoolAdminEmail\n            onboardComplete\n            testYears\n            schoolAdminInvitationCode\n            teacherInvitationCode\n            otherSchoolCode\n          }\n          createdAt\n          updatedAt\n        }\n      }\n    }\n  }\n"
    /**
     * __useJapanSchoolsQuery__
     *
     * To run a query within a React component, call `useJapanSchoolsQuery` and pass it any options that fit your needs.
     * When your component renders, `useJapanSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useJapanSchoolsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useJapanSchoolsQuery__
 *
 * To run a query within a React component, call `useJapanSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJapanSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJapanSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useJapanSchoolsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(JapanSchoolsDocument, options);
}
export function useJapanSchoolsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(JapanSchoolsDocument, options);
}
export var JapanSchoolCategoriesDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  query JapanSchoolCategories {\n    japanSchoolCategories {\n      data {\n        code\n        name\n      }\n    }\n  }\n"], ["\n  query JapanSchoolCategories {\n    japanSchoolCategories {\n      data {\n        code\n        name\n      }\n    }\n  }\n"
    /**
     * __useJapanSchoolCategoriesQuery__
     *
     * To run a query within a React component, call `useJapanSchoolCategoriesQuery` and pass it any options that fit your needs.
     * When your component renders, `useJapanSchoolCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useJapanSchoolCategoriesQuery({
     *   variables: {
     *   },
     * });
     */
])));
/**
 * __useJapanSchoolCategoriesQuery__
 *
 * To run a query within a React component, call `useJapanSchoolCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJapanSchoolCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJapanSchoolCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJapanSchoolCategoriesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(JapanSchoolCategoriesDocument, options);
}
export function useJapanSchoolCategoriesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(JapanSchoolCategoriesDocument, options);
}
export var JapanSchoolTypesDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  query JapanSchoolTypes {\n    japanSchoolTypes {\n      data {\n        code\n        name\n      }\n    }\n  }\n"], ["\n  query JapanSchoolTypes {\n    japanSchoolTypes {\n      data {\n        code\n        name\n      }\n    }\n  }\n"
    /**
     * __useJapanSchoolTypesQuery__
     *
     * To run a query within a React component, call `useJapanSchoolTypesQuery` and pass it any options that fit your needs.
     * When your component renders, `useJapanSchoolTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useJapanSchoolTypesQuery({
     *   variables: {
     *   },
     * });
     */
])));
/**
 * __useJapanSchoolTypesQuery__
 *
 * To run a query within a React component, call `useJapanSchoolTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJapanSchoolTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJapanSchoolTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useJapanSchoolTypesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(JapanSchoolTypesDocument, options);
}
export function useJapanSchoolTypesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(JapanSchoolTypesDocument, options);
}
export var SearchAreasHintsDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  query SearchAreasHints($input: SearchHintsInput!) {\n    searchAreasHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"], ["\n  query SearchAreasHints($input: SearchHintsInput!) {\n    searchAreasHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"
    /**
     * __useSearchAreasHintsQuery__
     *
     * To run a query within a React component, call `useSearchAreasHintsQuery` and pass it any options that fit your needs.
     * When your component renders, `useSearchAreasHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSearchAreasHintsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSearchAreasHintsQuery__
 *
 * To run a query within a React component, call `useSearchAreasHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAreasHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAreasHintsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAreasHintsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchAreasHintsDocument, options);
}
export function useSearchAreasHintsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchAreasHintsDocument, options);
}
export var SearchPrefecturesHintsDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  query SearchPrefecturesHints($input: SearchPrefecturesHintsInput!) {\n    searchPrefecturesHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"], ["\n  query SearchPrefecturesHints($input: SearchPrefecturesHintsInput!) {\n    searchPrefecturesHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"
    /**
     * __useSearchPrefecturesHintsQuery__
     *
     * To run a query within a React component, call `useSearchPrefecturesHintsQuery` and pass it any options that fit your needs.
     * When your component renders, `useSearchPrefecturesHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSearchPrefecturesHintsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSearchPrefecturesHintsQuery__
 *
 * To run a query within a React component, call `useSearchPrefecturesHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPrefecturesHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPrefecturesHintsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchPrefecturesHintsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchPrefecturesHintsDocument, options);
}
export function useSearchPrefecturesHintsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchPrefecturesHintsDocument, options);
}
export var SearchCitiesHintsDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  query SearchCitiesHints($input: SearchCitiesHintsInput!) {\n    searchCitiesHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"], ["\n  query SearchCitiesHints($input: SearchCitiesHintsInput!) {\n    searchCitiesHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"
    /**
     * __useSearchCitiesHintsQuery__
     *
     * To run a query within a React component, call `useSearchCitiesHintsQuery` and pass it any options that fit your needs.
     * When your component renders, `useSearchCitiesHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSearchCitiesHintsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSearchCitiesHintsQuery__
 *
 * To run a query within a React component, call `useSearchCitiesHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCitiesHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCitiesHintsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCitiesHintsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchCitiesHintsDocument, options);
}
export function useSearchCitiesHintsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchCitiesHintsDocument, options);
}
export var SearchJapanSchoolsHintsDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  query SearchJapanSchoolsHints($input: SearchJapanSchoolsHintsInput!) {\n    searchJapanSchoolsHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"], ["\n  query SearchJapanSchoolsHints($input: SearchJapanSchoolsHintsInput!) {\n    searchJapanSchoolsHints(input: $input) {\n      data {\n        term\n        score\n      }\n    }\n  }\n"
    /**
     * __useSearchJapanSchoolsHintsQuery__
     *
     * To run a query within a React component, call `useSearchJapanSchoolsHintsQuery` and pass it any options that fit your needs.
     * When your component renders, `useSearchJapanSchoolsHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSearchJapanSchoolsHintsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSearchJapanSchoolsHintsQuery__
 *
 * To run a query within a React component, call `useSearchJapanSchoolsHintsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchJapanSchoolsHintsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchJapanSchoolsHintsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchJapanSchoolsHintsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SearchJapanSchoolsHintsDocument, options);
}
export function useSearchJapanSchoolsHintsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SearchJapanSchoolsHintsDocument, options);
}
export var SchoolsDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  query Schools($input: SchoolsInput!) {\n    schools(input: $input) {\n      data {\n        _id\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"], ["\n  query Schools($input: SchoolsInput!) {\n    schools(input: $input) {\n      data {\n        _id\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"
    /**
     * __useSchoolsQuery__
     *
     * To run a query within a React component, call `useSchoolsQuery` and pass it any options that fit your needs.
     * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSchoolsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSchoolsQuery__
 *
 * To run a query within a React component, call `useSchoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SchoolsDocument, options);
}
export function useSchoolsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SchoolsDocument, options);
}
export var GradesDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  query Grades($input: SchoolGradesInput!) {\n    grades(input: $input) {\n      data {\n        testYear\n        schoolGrade\n        numberOfClasses\n        numberOfStudentsPerClass\n        isEnduranceRunInputActive\n      }\n      count\n      error\n    }\n  }\n"], ["\n  query Grades($input: SchoolGradesInput!) {\n    grades(input: $input) {\n      data {\n        testYear\n        schoolGrade\n        numberOfClasses\n        numberOfStudentsPerClass\n        isEnduranceRunInputActive\n      }\n      count\n      error\n    }\n  }\n"
    /**
     * __useGradesQuery__
     *
     * To run a query within a React component, call `useGradesQuery` and pass it any options that fit your needs.
     * When your component renders, `useGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useGradesQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useGradesQuery__
 *
 * To run a query within a React component, call `useGradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGradesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GradesDocument, options);
}
export function useGradesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GradesDocument, options);
}
export var TeachersDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  query Teachers($input: TeachersInput!) {\n    teachers(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          email\n        }\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"], ["\n  query Teachers($input: TeachersInput!) {\n    teachers(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          email\n        }\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"
    /**
     * __useTeachersQuery__
     *
     * To run a query within a React component, call `useTeachersQuery` and pass it any options that fit your needs.
     * When your component renders, `useTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useTeachersQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useTeachersQuery__
 *
 * To run a query within a React component, call `useTeachersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeachersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeachersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTeachersQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(TeachersDocument, options);
}
export function useTeachersLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(TeachersDocument, options);
}
export var StudentsDocument = gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  query Students($input: StudentsInput!) {\n    students(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          birthday\n          gender\n          schoolName\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n          studentNumber\n          email\n          testResults {\n            testYear\n            points\n            rank\n            age\n            grip {\n              gripLeft1\n              gripLeft2\n              gripRight1\n              gripRight2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sitUps {\n              sitUps\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            bending {\n              bending1\n              bending2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sideJump {\n              sideJump1\n              sideJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            shuttleRun {\n              shuttleRunCount\n              shuttleRunGainOxygen\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sprintRun {\n              sprintRunSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            standingJump {\n              standingJump1\n              standingJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            handballThrow {\n              handballThrow1\n              handballThrow2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            enduranceRun {\n              runningTime\n              runningTimeSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            questionnaire {\n              belongsToSportsClub\n              excerciseActivity\n              dailyExcerciseTime\n              breakfast\n              sleepTime\n              tvTime\n              height\n              weight\n              sittingHeight\n            }\n            questionnaireV2 {\n              height\n              weight\n              sittingHeight\n              answers\n            }\n          }\n        }\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"], ["\n  query Students($input: StudentsInput!) {\n    students(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          birthday\n          gender\n          schoolName\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n          studentNumber\n          email\n          testResults {\n            testYear\n            points\n            rank\n            age\n            grip {\n              gripLeft1\n              gripLeft2\n              gripRight1\n              gripRight2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sitUps {\n              sitUps\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            bending {\n              bending1\n              bending2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sideJump {\n              sideJump1\n              sideJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            shuttleRun {\n              shuttleRunCount\n              shuttleRunGainOxygen\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sprintRun {\n              sprintRunSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            standingJump {\n              standingJump1\n              standingJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            handballThrow {\n              handballThrow1\n              handballThrow2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            enduranceRun {\n              runningTime\n              runningTimeSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            questionnaire {\n              belongsToSportsClub\n              excerciseActivity\n              dailyExcerciseTime\n              breakfast\n              sleepTime\n              tvTime\n              height\n              weight\n              sittingHeight\n            }\n            questionnaireV2 {\n              height\n              weight\n              sittingHeight\n              answers\n            }\n          }\n        }\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"
    /**
     * __useStudentsQuery__
     *
     * To run a query within a React component, call `useStudentsQuery` and pass it any options that fit your needs.
     * When your component renders, `useStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useStudentsQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useStudentsQuery__
 *
 * To run a query within a React component, call `useStudentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentsQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudentsDocument, options);
}
export function useStudentsLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudentsDocument, options);
}
export var RenewTokenDocument = gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  query RenewToken {\n    me {\n      token\n      error\n    }\n  }\n"], ["\n  query RenewToken {\n    me {\n      token\n      error\n    }\n  }\n"
    /**
     * __useRenewTokenQuery__
     *
     * To run a query within a React component, call `useRenewTokenQuery` and pass it any options that fit your needs.
     * When your component renders, `useRenewTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useRenewTokenQuery({
     *   variables: {
     *   },
     * });
     */
])));
/**
 * __useRenewTokenQuery__
 *
 * To run a query within a React component, call `useRenewTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenewTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenewTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useRenewTokenQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(RenewTokenDocument, options);
}
export function useRenewTokenLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(RenewTokenDocument, options);
}
export var MeDocument = gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  query Me {\n    me {\n      token\n      error\n      data {\n        _id\n        attributes {\n          role\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          gender\n          birthday\n          schoolName\n          schoolCategoryCode\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n          studentNumber\n          email\n          testResults {\n            testYear\n            points\n            rank\n            age\n            grip {\n              gripLeft1\n              gripLeft2\n              gripRight1\n              gripRight2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sitUps {\n              sitUps\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            bending {\n              bending1\n              bending2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sideJump {\n              sideJump1\n              sideJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            shuttleRun {\n              shuttleRunCount\n              shuttleRunGainOxygen\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sprintRun {\n              sprintRunSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            standingJump {\n              standingJump1\n              standingJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            handballThrow {\n              handballThrow1\n              handballThrow2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            enduranceRun {\n              runningTime\n              runningTimeSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            questionnaire {\n              belongsToSportsClub\n              excerciseActivity\n              dailyExcerciseTime\n              breakfast\n              sleepTime\n              tvTime\n              height\n              weight\n              sittingHeight\n            }\n            questionnaireV2 {\n              height\n              weight\n              sittingHeight\n              answers\n            }\n          }\n        }\n        relationships {\n          schools {\n            _id\n            attributes {\n              email\n              fax\n              telephone\n              website\n              schoolName\n              schoolCategoryCode\n              schoolAdminName\n              schoolAddress\n              onboardComplete\n              testYears\n              isStudentInputActive\n              isEnduranceRunInputActive\n              questions {\n                question\n                options\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query Me {\n    me {\n      token\n      error\n      data {\n        _id\n        attributes {\n          role\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          gender\n          birthday\n          schoolName\n          schoolCategoryCode\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n          studentNumber\n          email\n          testResults {\n            testYear\n            points\n            rank\n            age\n            grip {\n              gripLeft1\n              gripLeft2\n              gripRight1\n              gripRight2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sitUps {\n              sitUps\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            bending {\n              bending1\n              bending2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sideJump {\n              sideJump1\n              sideJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            shuttleRun {\n              shuttleRunCount\n              shuttleRunGainOxygen\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            sprintRun {\n              sprintRunSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            standingJump {\n              standingJump1\n              standingJump2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            handballThrow {\n              handballThrow1\n              handballThrow2\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            enduranceRun {\n              runningTime\n              runningTimeSeconds\n              isNotMeasurable\n              value\n              points\n              memo\n              rating\n              comment\n            }\n            questionnaire {\n              belongsToSportsClub\n              excerciseActivity\n              dailyExcerciseTime\n              breakfast\n              sleepTime\n              tvTime\n              height\n              weight\n              sittingHeight\n            }\n            questionnaireV2 {\n              height\n              weight\n              sittingHeight\n              answers\n            }\n          }\n        }\n        relationships {\n          schools {\n            _id\n            attributes {\n              email\n              fax\n              telephone\n              website\n              schoolName\n              schoolCategoryCode\n              schoolAdminName\n              schoolAddress\n              onboardComplete\n              testYears\n              isStudentInputActive\n              isEnduranceRunInputActive\n              questions {\n                question\n                options\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"
    /**
     * __useMeQuery__
     *
     * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
     * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useMeQuery({
     *   variables: {
     *   },
     * });
     */
])));
/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MeDocument, options);
}
export function useMeLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MeDocument, options);
}
export var ReportCountSummaryDocument = gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  query ReportCountSummary($input: ReportCountSummaryInput!) {\n    reportCountSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportCountSummary($input: ReportCountSummaryInput!) {\n    reportCountSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          schoolCount\n          reports {\n            grade\n            male {\n              totalCount\n              samplingCount\n            }\n            female {\n              totalCount\n              samplingCount\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportCountSummaryQuery__
     *
     * To run a query within a React component, call `useReportCountSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportCountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportCountSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportCountSummaryQuery__
 *
 * To run a query within a React component, call `useReportCountSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCountSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCountSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCountSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportCountSummaryDocument, options);
}
export function useReportCountSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportCountSummaryDocument, options);
}
export var ReportBodySummaryDocument = gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  query ReportBodySummary($input: ReportBodySummaryInput!) {\n    reportBodySummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportBodySummary($input: ReportBodySummaryInput!) {\n    reportBodySummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            sampleCount\n            heightAvg\n            weightAvg\n            heightDev\n            weightDev\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportBodySummaryQuery__
     *
     * To run a query within a React component, call `useReportBodySummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportBodySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportBodySummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportBodySummaryQuery__
 *
 * To run a query within a React component, call `useReportBodySummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportBodySummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportBodySummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportBodySummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportBodySummaryDocument, options);
}
export function useReportBodySummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportBodySummaryDocument, options);
}
export var ReportTestSummaryDocument = gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  query ReportTestSummary($input: ReportTestSummaryInput!) {\n    reportTestSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportTestSummary($input: ReportTestSummaryInput!) {\n    reportTestSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            average {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            deviation {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportTestSummaryQuery__
     *
     * To run a query within a React component, call `useReportTestSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportTestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportTestSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportTestSummaryQuery__
 *
 * To run a query within a React component, call `useReportTestSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTestSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportTestSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportTestSummaryDocument, options);
}
export function useReportTestSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportTestSummaryDocument, options);
}
export var ReportTestComparisonSummaryDocument = gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  query ReportTestComparisonSummary($input: ReportTestComparisonSummaryInput!) {\n    reportTestComparisonSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportTestComparisonSummary($input: ReportTestComparisonSummaryInput!) {\n    reportTestComparisonSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n            national {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportTestComparisonSummaryQuery__
     *
     * To run a query within a React component, call `useReportTestComparisonSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportTestComparisonSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportTestComparisonSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportTestComparisonSummaryQuery__
 *
 * To run a query within a React component, call `useReportTestComparisonSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTestComparisonSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTestComparisonSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportTestComparisonSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportTestComparisonSummaryDocument, options);
}
export function useReportTestComparisonSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportTestComparisonSummaryDocument, options);
}
export var ReportAverageScoreGraphSummaryDocument = gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  query ReportAverageScoreGraphSummary(\n    $input: ReportAverageScoreGraphSummaryInput!\n  ) {\n    reportAverageScoreGraphSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportAverageScoreGraphSummary(\n    $input: ReportAverageScoreGraphSummaryInput!\n  ) {\n    reportAverageScoreGraphSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            year\n            grades {\n              grade\n              score {\n                grip\n                sitUps\n                bending\n                sideJump\n                shuttleRun\n                sprintRun\n                standingJump\n                handballThrow\n                totalScore\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportAverageScoreGraphSummaryQuery__
     *
     * To run a query within a React component, call `useReportAverageScoreGraphSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportAverageScoreGraphSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportAverageScoreGraphSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportAverageScoreGraphSummaryQuery__
 *
 * To run a query within a React component, call `useReportAverageScoreGraphSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAverageScoreGraphSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAverageScoreGraphSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportAverageScoreGraphSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportAverageScoreGraphSummaryDocument, options);
}
export function useReportAverageScoreGraphSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportAverageScoreGraphSummaryDocument, options);
}
export var ReportTestRankSummaryDocument = gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  query ReportTestRankSummary($input: ReportTestRankSummaryInput!) {\n    reportTestRankSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportTestRankSummary($input: ReportTestRankSummaryInput!) {\n    reportTestRankSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        allDayHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n        fixTimeHighSchoolReport {\n          reports {\n            grade\n            totalCount\n            countByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n            rateByRank {\n              rankA\n              rankB\n              rankC\n              rankD\n              rankE\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportTestRankSummaryQuery__
     *
     * To run a query within a React component, call `useReportTestRankSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportTestRankSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportTestRankSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportTestRankSummaryQuery__
 *
 * To run a query within a React component, call `useReportTestRankSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTestRankSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTestRankSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportTestRankSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportTestRankSummaryDocument, options);
}
export function useReportTestRankSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportTestRankSummaryDocument, options);
}
export var ReportQuestionnaireSummaryDocument = gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  query ReportQuestionnaireSummary($input: ReportQuestionnaireSummaryInput!) {\n    reportQuestionnaireSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportQuestionnaireSummary($input: ReportQuestionnaireSummaryInput!) {\n    reportQuestionnaireSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            countByAnswer {\n              q1 {\n                k\n                v\n              }\n              q2 {\n                k\n                v\n              }\n              q3 {\n                k\n                v\n              }\n              q4 {\n                k\n                v\n              }\n              q5 {\n                k\n                v\n              }\n              q6 {\n                k\n                v\n              }\n              q7 {\n                k\n                v\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportQuestionnaireSummaryQuery__
     *
     * To run a query within a React component, call `useReportQuestionnaireSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportQuestionnaireSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportQuestionnaireSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportQuestionnaireSummaryQuery__
 *
 * To run a query within a React component, call `useReportQuestionnaireSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportQuestionnaireSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportQuestionnaireSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportQuestionnaireSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportQuestionnaireSummaryDocument, options);
}
export function useReportQuestionnaireSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportQuestionnaireSummaryDocument, options);
}
export var ReportTestScoreChartSummaryDocument = gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  query ReportTestScoreChartSummary($input: ReportTestScoreChartSummaryInput!) {\n    reportTestScoreChartSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportTestScoreChartSummary($input: ReportTestScoreChartSummaryInput!) {\n    reportTestScoreChartSummary(input: $input) {\n      data {\n        elementarySchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n        juniorHighSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n        highSchoolReport {\n          reports {\n            grade\n            prefecture {\n              grip\n              sitUps\n              bending\n              sideJump\n              shuttleRun\n              sprintRun\n              standingJump\n              handballThrow\n              totalScore\n              height\n              weight\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportTestScoreChartSummaryQuery__
     *
     * To run a query within a React component, call `useReportTestScoreChartSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportTestScoreChartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportTestScoreChartSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportTestScoreChartSummaryQuery__
 *
 * To run a query within a React component, call `useReportTestScoreChartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTestScoreChartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTestScoreChartSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportTestScoreChartSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportTestScoreChartSummaryDocument, options);
}
export function useReportTestScoreChartSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportTestScoreChartSummaryDocument, options);
}
export var ReportTestRankTargetSummaryDocument = gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n  query ReportTestRankTargetSummary($input: ReportTestRankTargetSummaryInput!) {\n    reportTestRankTargetSummary(input: $input) {\n      data {\n        reports {\n          year\n          totalRates\n          elementarySchoolRates\n          juniorHighSchoolRates\n          highSchoolRates\n        }\n        national {\n          year\n          totalRates\n          elementarySchoolRates\n          juniorHighSchoolRates\n          highSchoolRates\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportTestRankTargetSummary($input: ReportTestRankTargetSummaryInput!) {\n    reportTestRankTargetSummary(input: $input) {\n      data {\n        reports {\n          year\n          totalRates\n          elementarySchoolRates\n          juniorHighSchoolRates\n          highSchoolRates\n        }\n        national {\n          year\n          totalRates\n          elementarySchoolRates\n          juniorHighSchoolRates\n          highSchoolRates\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportTestRankTargetSummaryQuery__
     *
     * To run a query within a React component, call `useReportTestRankTargetSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportTestRankTargetSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportTestRankTargetSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportTestRankTargetSummaryQuery__
 *
 * To run a query within a React component, call `useReportTestRankTargetSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTestRankTargetSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTestRankTargetSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportTestRankTargetSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportTestRankTargetSummaryDocument, options);
}
export function useReportTestRankTargetSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportTestRankTargetSummaryDocument, options);
}
export var ReportCrossAnalysisSummaryDocument = gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n  query ReportCrossAnalysisSummary($input: ReportCrossAnalysisSummaryInput!) {\n    reportCrossAnalysisSummary(input: $input) {\n      data {\n        reports {\n          dataKey\n          grades {\n            schoolCategory\n            grade\n            answers {\n              answer\n              totalCount\n              averages {\n                score\n                scoreType\n              }\n              deviations {\n                score\n                scoreType\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportCrossAnalysisSummary($input: ReportCrossAnalysisSummaryInput!) {\n    reportCrossAnalysisSummary(input: $input) {\n      data {\n        reports {\n          dataKey\n          grades {\n            schoolCategory\n            grade\n            answers {\n              answer\n              totalCount\n              averages {\n                score\n                scoreType\n              }\n              deviations {\n                score\n                scoreType\n              }\n            }\n          }\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportCrossAnalysisSummaryQuery__
     *
     * To run a query within a React component, call `useReportCrossAnalysisSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportCrossAnalysisSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportCrossAnalysisSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportCrossAnalysisSummaryQuery__
 *
 * To run a query within a React component, call `useReportCrossAnalysisSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportCrossAnalysisSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportCrossAnalysisSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportCrossAnalysisSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportCrossAnalysisSummaryDocument, options);
}
export function useReportCrossAnalysisSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportCrossAnalysisSummaryDocument, options);
}
export var ReportSchoolPerformanceSummaryDocument = gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n  query ReportSchoolPerformanceSummary(\n    $input: ReportSchoolPerformanceSummaryInput!\n  ) {\n    reportSchoolPerformanceSummary(input: $input) {\n      data {\n        elementarySchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        juniorHighSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        highSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportSchoolPerformanceSummary(\n    $input: ReportSchoolPerformanceSummaryInput!\n  ) {\n    reportSchoolPerformanceSummary(input: $input) {\n      data {\n        elementarySchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        juniorHighSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        highSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportSchoolPerformanceSummaryQuery__
     *
     * To run a query within a React component, call `useReportSchoolPerformanceSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportSchoolPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportSchoolPerformanceSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportSchoolPerformanceSummaryQuery__
 *
 * To run a query within a React component, call `useReportSchoolPerformanceSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSchoolPerformanceSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSchoolPerformanceSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportSchoolPerformanceSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportSchoolPerformanceSummaryDocument, options);
}
export function useReportSchoolPerformanceSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportSchoolPerformanceSummaryDocument, options);
}
export var ReportSchoolProgressSummaryDocument = gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n  query ReportSchoolProgressSummary($input: ReportSchoolProgressSummaryInput!) {\n    reportSchoolProgressSummary(input: $input) {\n      data {\n        elementarySchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        juniorHighSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        highSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query ReportSchoolProgressSummary($input: ReportSchoolProgressSummaryInput!) {\n    reportSchoolProgressSummary(input: $input) {\n      data {\n        elementarySchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        juniorHighSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n        highSchool {\n          prefectureSchoolCode\n          schoolName\n          scale\n          score\n          studentCount\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useReportSchoolProgressSummaryQuery__
     *
     * To run a query within a React component, call `useReportSchoolProgressSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportSchoolProgressSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportSchoolProgressSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportSchoolProgressSummaryQuery__
 *
 * To run a query within a React component, call `useReportSchoolProgressSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSchoolProgressSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSchoolProgressSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportSchoolProgressSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportSchoolProgressSummaryDocument, options);
}
export function useReportSchoolProgressSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportSchoolProgressSummaryDocument, options);
}
export var ReportUploadListDocument = gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n  query ReportUploadList($input: ReportUploadListInput!) {\n    reportUploadList(input: $input) {\n      data {\n        prefectureSchoolCode\n        schoolName\n        studentCount\n        cityName\n        organizationName\n        uploadedAt\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"], ["\n  query ReportUploadList($input: ReportUploadListInput!) {\n    reportUploadList(input: $input) {\n      data {\n        prefectureSchoolCode\n        schoolName\n        studentCount\n        cityName\n        organizationName\n        uploadedAt\n      }\n      count\n      totalCount\n      error\n    }\n  }\n"
    /**
     * __useReportUploadListQuery__
     *
     * To run a query within a React component, call `useReportUploadListQuery` and pass it any options that fit your needs.
     * When your component renders, `useReportUploadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useReportUploadListQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useReportUploadListQuery__
 *
 * To run a query within a React component, call `useReportUploadListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportUploadListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportUploadListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportUploadListQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ReportUploadListDocument, options);
}
export function useReportUploadListLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ReportUploadListDocument, options);
}
export var StudentInvitationCodesDocument = gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n  query StudentInvitationCodes($input: StudentInvitationCodesInput!) {\n    studentInvitationCodes(input: $input) {\n      data {\n        schoolGrade\n        schoolClass\n        code\n        testYear\n      }\n      error\n    }\n  }\n"], ["\n  query StudentInvitationCodes($input: StudentInvitationCodesInput!) {\n    studentInvitationCodes(input: $input) {\n      data {\n        schoolGrade\n        schoolClass\n        code\n        testYear\n      }\n      error\n    }\n  }\n"
    /**
     * __useStudentInvitationCodesQuery__
     *
     * To run a query within a React component, call `useStudentInvitationCodesQuery` and pass it any options that fit your needs.
     * When your component renders, `useStudentInvitationCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useStudentInvitationCodesQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useStudentInvitationCodesQuery__
 *
 * To run a query within a React component, call `useStudentInvitationCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentInvitationCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentInvitationCodesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStudentInvitationCodesQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(StudentInvitationCodesDocument, options);
}
export function useStudentInvitationCodesLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(StudentInvitationCodesDocument, options);
}
export var SchoolReportTestSummaryDocument = gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  query SchoolReportTestSummary($input: SchoolReportTestSummaryInput!) {\n    schoolReportTestSummary(input: $input) {\n      data {\n        reports {\n          testYear\n          grade\n          count\n          height_avg\n          weight_avg\n          grip_avg\n          sitUps_avg\n          bending_avg\n          sideJump_avg\n          shuttleRun_avg\n          sprintRun_avg\n          standingJump_avg\n          handballThrow_avg\n          points_avg\n          height_std\n          weight_std\n          grip_std\n          sitUps_std\n          bending_std\n          sideJump_std\n          shuttleRun_std\n          sprintRun_std\n          standingJump_std\n          handballThrow_std\n          points_std\n          rank_a\n          rank_b\n          rank_c\n          rank_d\n          rank_e\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query SchoolReportTestSummary($input: SchoolReportTestSummaryInput!) {\n    schoolReportTestSummary(input: $input) {\n      data {\n        reports {\n          testYear\n          grade\n          count\n          height_avg\n          weight_avg\n          grip_avg\n          sitUps_avg\n          bending_avg\n          sideJump_avg\n          shuttleRun_avg\n          sprintRun_avg\n          standingJump_avg\n          handballThrow_avg\n          points_avg\n          height_std\n          weight_std\n          grip_std\n          sitUps_std\n          bending_std\n          sideJump_std\n          shuttleRun_std\n          sprintRun_std\n          standingJump_std\n          handballThrow_std\n          points_std\n          rank_a\n          rank_b\n          rank_c\n          rank_d\n          rank_e\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useSchoolReportTestSummaryQuery__
     *
     * To run a query within a React component, call `useSchoolReportTestSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useSchoolReportTestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSchoolReportTestSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSchoolReportTestSummaryQuery__
 *
 * To run a query within a React component, call `useSchoolReportTestSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolReportTestSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolReportTestSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolReportTestSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SchoolReportTestSummaryDocument, options);
}
export function useSchoolReportTestSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SchoolReportTestSummaryDocument, options);
}
export var SchoolReportTestScoreChartSummaryDocument = gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n  query SchoolReportTestScoreChartSummary(\n    $input: SchoolReportTestScoreChartSummaryInput!\n  ) {\n    schoolReportTestScoreChartSummary(input: $input) {\n      data {\n        reports {\n          testYear\n          grade\n          chart {\n            grip\n            sitUps\n            bending\n            sideJump\n            shuttleRun\n            sprintRun\n            standingJump\n            handballThrow\n            totalScore\n            height\n            weight\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query SchoolReportTestScoreChartSummary(\n    $input: SchoolReportTestScoreChartSummaryInput!\n  ) {\n    schoolReportTestScoreChartSummary(input: $input) {\n      data {\n        reports {\n          testYear\n          grade\n          chart {\n            grip\n            sitUps\n            bending\n            sideJump\n            shuttleRun\n            sprintRun\n            standingJump\n            handballThrow\n            totalScore\n            height\n            weight\n          }\n        }\n      }\n    }\n  }\n"
    /**
     * __useSchoolReportTestScoreChartSummaryQuery__
     *
     * To run a query within a React component, call `useSchoolReportTestScoreChartSummaryQuery` and pass it any options that fit your needs.
     * When your component renders, `useSchoolReportTestScoreChartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useSchoolReportTestScoreChartSummaryQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useSchoolReportTestScoreChartSummaryQuery__
 *
 * To run a query within a React component, call `useSchoolReportTestScoreChartSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolReportTestScoreChartSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolReportTestScoreChartSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchoolReportTestScoreChartSummaryQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(SchoolReportTestScoreChartSummaryDocument, options);
}
export function useSchoolReportTestScoreChartSummaryLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(SchoolReportTestScoreChartSummaryDocument, options);
}
export var QrCodeStudentDocument = gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n  query QRCodeStudent($input: QRCodeStudentInput!) {\n    qrCodeStudent(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          schoolName\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n        }\n      }\n      error\n    }\n  }\n"], ["\n  query QRCodeStudent($input: QRCodeStudentInput!) {\n    qrCodeStudent(input: $input) {\n      data {\n        _id\n        attributes {\n          givenName\n          givenNameHiragana\n          familyName\n          familyNameHiragana\n          schoolName\n          schoolGrade\n          schoolClass\n          schoolAttendanceNumber\n        }\n      }\n      error\n    }\n  }\n"
    /**
     * __useQrCodeStudentQuery__
     *
     * To run a query within a React component, call `useQrCodeStudentQuery` and pass it any options that fit your needs.
     * When your component renders, `useQrCodeStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
     * you can use to render your UI.
     *
     * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
     *
     * @example
     * const { data, loading, error } = useQrCodeStudentQuery({
     *   variables: {
     *      input: // value for 'input'
     *   },
     * });
     */
])));
/**
 * __useQrCodeStudentQuery__
 *
 * To run a query within a React component, call `useQrCodeStudentQuery` and pass it any options that fit your needs.
 * When your component renders, `useQrCodeStudentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQrCodeStudentQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQrCodeStudentQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(QrCodeStudentDocument, options);
}
export function useQrCodeStudentLazyQuery(baseOptions) {
    var options = __assign(__assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(QrCodeStudentDocument, options);
}
var result = {
    possibleTypes: {},
};
export default result;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61;
